import { createSlice } from "@reduxjs/toolkit";
import { IPriceOverrideConfigResponse } from "../../typings/interfaces/responses/priceOverrideConfigResponse";
import {
    createPriceOverrideConfigAction,
    deletePriceOverrideConfigAction,
    getActivePriceOverrideConfigsAction,
    getAllPriceOverrideConfigsAction,
    updatePriceOverrideConfigAction,
} from "../actions/priceOverrideConfigAction";

export interface PriceOverrideConfigState {
    configs: IPriceOverrideConfigResponse[] | null;
    configsLoading: boolean;
    configsError: string | null;

    activeConfigs: IPriceOverrideConfigResponse[] | null;
    activeConfigsLoading: boolean;
    activeConfigsError: string | null;

    addConfigResponse: IPriceOverrideConfigResponse | null;
    addConfigLoading: boolean;
    addConfigError: string | null;

    deleteConfigLoading: boolean;
    deleteConfigError: string | null;

    updateConfigResponse: IPriceOverrideConfigResponse | null;
    updateConfigLoading: boolean;
    updateConfigError: string | null;
}

const initialState: PriceOverrideConfigState = {
    configs: null,
    configsLoading: false,
    configsError: null,

    activeConfigs: null,
    activeConfigsLoading: false,
    activeConfigsError: null,

    addConfigResponse: null,
    addConfigLoading: false,
    addConfigError: null,

    deleteConfigLoading: false,
    deleteConfigError: null,

    updateConfigResponse: null,
    updateConfigLoading: false,
    updateConfigError: null,
};

const priceOverrideConfigSlice = createSlice({
    name: "priceOverrideConfig",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // get all
        builder
            .addCase(getAllPriceOverrideConfigsAction.pending, (state) => {
                state.configs = null;
                state.configsLoading = true;
                state.configsError = null;
            })
            .addCase(getAllPriceOverrideConfigsAction.fulfilled, (state, action) => {
                state.configsLoading = false;
                state.configs = (action.payload as any).body;
            })
            .addCase(getAllPriceOverrideConfigsAction.rejected, (state, action) => {
                state.configsLoading = false;
                state.configsError = (action.payload as any).message;
            });

        // get active
        builder
            .addCase(getActivePriceOverrideConfigsAction.pending, (state) => {
                state.activeConfigs = null;
                state.activeConfigsLoading = true;
                state.activeConfigsError = null;
            })
            .addCase(getActivePriceOverrideConfigsAction.fulfilled, (state, action) => {
                state.activeConfigsLoading = false;
                state.activeConfigs = (action.payload as any).body;
            })
            .addCase(getActivePriceOverrideConfigsAction.rejected, (state, action) => {
                state.activeConfigsLoading = false;
                state.activeConfigsError = (action.payload as any).message;
            });

        // create
        builder
            .addCase(createPriceOverrideConfigAction.pending, (state) => {
                state.addConfigResponse = null;
                state.addConfigLoading = true;
                state.addConfigError = null;
            })
            .addCase(createPriceOverrideConfigAction.fulfilled, (state, action) => {
                state.addConfigResponse = (action.payload as any).body;
                state.addConfigLoading = false;
            })
            .addCase(createPriceOverrideConfigAction.rejected, (state, action) => {
                state.addConfigLoading = false;
                state.addConfigError = (action.payload as any).message;
            });

        // update
        builder
            .addCase(updatePriceOverrideConfigAction.pending, (state) => {
                state.updateConfigResponse = null;
                state.updateConfigLoading = true;
                state.updateConfigError = null;
            })
            .addCase(updatePriceOverrideConfigAction.fulfilled, (state, action) => {
                state.updateConfigResponse = (action.payload as any).body;
                state.updateConfigLoading = false;
            })
            .addCase(updatePriceOverrideConfigAction.rejected, (state, action) => {
                state.updateConfigLoading = false;
                state.updateConfigError = (action.payload as any).message;
            });

        // delete
        builder
            .addCase(deletePriceOverrideConfigAction.pending, (state) => {
                state.deleteConfigLoading = true;
                state.deleteConfigError = null;
            })
            .addCase(deletePriceOverrideConfigAction.fulfilled, (state) => {
                state.deleteConfigLoading = false;
            })
            .addCase(deletePriceOverrideConfigAction.rejected, (state, action) => {
                state.deleteConfigLoading = false;
                state.deleteConfigError = (action.payload as any).message;
            });
    },
});

export default priceOverrideConfigSlice.reducer;
export const priceOverrideConfigSliceActions = priceOverrideConfigSlice.actions;
